import { Ok } from '@atom-learning/icons'
import * as ToggleGroup from '@radix-ui/react-toggle-group'
import * as React from 'react'

import { Chip } from '~/components/chip/Chip'
import { Icon } from '~/components/icon/Icon'
import { styled } from '~/styled'

const StyledChipToggleIcon = styled(Icon, {
  base: ['hidden']
})

const StyledChipToggleGroupItem = styled(Chip, {
  base: [
    'flex',
    'not-disabled:cursor-pointer',
    'not-disabled:data-[state=on]:hover:bg-white',
    'not-disabled:data-[state=on]:hover:text-primary-1000',
    'not-disabled:focus-visible:outline-none',
    'not-disabled:focus-visible:relative',
    'not-disabled:focus-visible:shadow-[var(--color-primary-800)_0px_0px_0px_4px]',
    'not-disabled:focus-visible:shadow-[white_0px_0px_0px_2px]',
    'not-disabled:focus-visible:z-1',
    'not-disabled:hover:bg-grey-200',
    'not-disabled:hover:border-current',
    'not-disabled:hover:text-grey-1000',
    'data-[state=off]:bg-white',
    'data-[state=off]:border-grey-600',
    'data-[state=off]:text-grey-800',
    'data-[state=on]:[&_svg]:block'
  ],
  variants: {
    appearance: {
      standard: [],
      modern: [
        'data-[state=off]:bg-grey-100',
        'data-[state=off]:border-transparent',
        'data-[state=on]:border-grey-900',
        'data-[state=on]:text-grey-900',
        'data-[state=on]:bg-white',
        'data-[state=on]:font-bold'
      ]
    }
  }
})

type TChipToggleGroupItem = React.ComponentProps<typeof ToggleGroup.Item> &
  React.ComponentProps<typeof StyledChipToggleGroupItem>

export const ChipToggleGroupItem = ({
  size = 'md',
  appearance,
  children,
  ...rest
}: TChipToggleGroupItem) => {
  return (
    <ToggleGroup.Item {...rest} asChild>
      <StyledChipToggleGroupItem as="button" appearance={appearance}>
        <StyledChipToggleIcon is={Ok} size={size === 'lg' ? 'md' : 'sm'} />
        <Chip.Content>{children}</Chip.Content>
      </StyledChipToggleGroupItem>
    </ToggleGroup.Item>
  )
}
